export default __webpack_public_path__ + "static/media/ReimbursementIcon.6bccf4f2.svg";